import { butcherSubscriptionsStatus } from '@helpers/Constants';

/**
 * Determines whether the current subscription is in a restricted state.
 *
 * @returns {boolean} Returns `true` if the subscription status is
 * PENDING, SUSPENDED, or CANCELLED; otherwise, returns `false`.
 *
 * @remarks
 * - The subscription status is retrieved from `localStorage`.
 * - This function is typically used to control access to features
 *   when the subscription is not active.
 */
export const SubscriptionValidation = (): boolean => {
  const subscriptionStatus = Number(localStorage.getItem('subscriptionStatus'));

  return (
    subscriptionStatus === butcherSubscriptionsStatus.PENDING ||
    subscriptionStatus === butcherSubscriptionsStatus.SUSPENDED ||
    subscriptionStatus === butcherSubscriptionsStatus.CANCELLED
  );
};
